import React, {Component} from 'react'

import {InputAdornment, withStyles} from '@material-ui/core'
import {cardLogos, formatCardNumber, getLengthsById, getMask, validateBin, findPaymentMethodIdByBin, validateLuhnAlgorithm} from './cardsHelper'
import withValidation from '../../../../container/withValidation'
import style from './style'
import CustomTextField from '../CustomTextField'
import isArray from 'lodash/isArray'
import size from 'lodash/size'
import head from 'lodash/head'
import { GENERIC } from '../../../../shared/constants'

class CardNumberInput extends Component {

    constructor(props) {
        super(props)

        this.state = {
            value: "",
            fullValue: props.cardBin,
            cardLogo: GENERIC,
            paymentMethodId: props.paymentMethod,
            error: false,
            errorMessage: ""
        }

        const binRanges = props.binRanges
        this.sortedPaymentMethods =
            Object.keys(binRanges)
                .filter(paymentMethodId => props.paymentMethod.includes(parseInt(paymentMethodId)))
                .sort((a, b) => binRanges[a].priority - binRanges[b].priority )

    }

    handleChange = (e) => {
        const paymentMethod = this.state.paymentMethodId
        const maxLength = getLengthsById(paymentMethod)[0]
        const value = e.target.value.replace(/ /g, "")
        const fullValue = `${this.props.cardBin}${value}`.substring(0, maxLength)
        const error = !validateBin(fullValue, paymentMethod, this.props.binRanges)
        let newState = this.getPaymentMethodAndCardLogo(fullValue, error)
        this.setState({...newState, value: value})
        this.props.updateCardData({
            key: 'card_number',
            value: fullValue,
            paymentMethodId: isArray(newState.paymentMethodId) ? null : newState.paymentMethodId
        })

        e.target.value = fullValue
        this.props.onChange(e)
    }

    componentDidMount = () => {
        this.setState({...this.getPaymentMethodAndCardLogo(this.state.fullValue, this.state.error), value: this.state.value})
    }

    getPaymentMethodAndCardLogo = (fullValue, validationBinError) => {
        let paymentMethod = this.props.paymentMethod
        let cardLogo = GENERIC
        let error = validationBinError
        let errorMessage = error ? "Encontramos un error en esta tarjeta" : ""

        if (paymentMethod.length === 1) {
            paymentMethod = paymentMethod[0]
            cardLogo = cardLogos[paymentMethod] || GENERIC
        }
        else if (fullValue.length >= 6) {
            paymentMethod = findPaymentMethodIdByBin(fullValue, this.props.binRanges, this.sortedPaymentMethods)

            if (paymentMethod) {
                error = false
                errorMessage = ""
                cardLogo = cardLogos[paymentMethod] || GENERIC
            }
            else {
                error = true
                errorMessage = "Encontramos un error en esta tarjeta"
            }
        }
        return {
            fullValue: fullValue,
            paymentMethodId: paymentMethod,
            cardLogo: cardLogo,
            error: error,
            errorMessage: errorMessage
        }
    }

    render() {
        const { classes, cardBin, error, errorMessage, tabIndex, updateCardData, paymentMethodId, paymentMethod: originalPaymentMethod, binRanges,
            /* Se agregan estas properties debido a un error que se visualiza en la consola por pasar el restOfProps al CustomTextField 
               ya que no las utiliza, sin embargo son utilizadas por el withValidation */
            registerValidation, validateInput, validate, ...restOfProps } = this.props
        
        const fullValue = this.state.fullValue
        const paymentMethod = parseInt(
            (size(originalPaymentMethod) === 1 && head(originalPaymentMethod)) || paymentMethodId
        )

        const mask = getMask(fullValue, paymentMethod)
        const formatted = formatCardNumber(cardBin, this.state.value, mask)

        const inputProps = {
            endAdornment:
                <InputAdornment position="end" className={classes.cardLogo}>
                    <img alt="" src={`${window.env.ASSETS_URL}/images/cards/${this.state.cardLogo}.svg`}/>
                </InputAdornment>
        }

        const shownError = this.state.error || error
        const shownErrorMessage = this.state.errorMessage || errorMessage

        if (cardBin)
            inputProps.startAdornment =
                <InputAdornment position="start" className={classes.cardBin}>{formatted.bin}</InputAdornment>

        return (
            <React.Fragment>
                <CustomTextField
                    id="cardNumber"
                    label="Número"
                    type="text"
                    helperText=" "
                    InputProps={inputProps}
                    errorMessage={shownErrorMessage}
                    error={shownError}
                    {...restOfProps}
                    value={formatted.restOfCC}
                    onChange={this.handleChange}
                    tabIndex={tabIndex}
                />
                <input type="hidden" name="card_data.card_number" value={this.state.fullValue}/>
            </React.Fragment>

        )
    }

}

function validation(value, props) {
    const {paymentMethod: originalPaymentMethod, paymentMethodId, binRanges} = props
    const paymentMethod = parseInt(
        (size(originalPaymentMethod) === 1 && head(originalPaymentMethod)) || paymentMethodId
    )
    let validateLuhn = false

    if (value.length === 0) return {
        isValid: false,
        message: "Completa este dato"
    }

    const lengths = getLengthsById(paymentMethod)

    if (paymentMethodId) {
        validateLuhn = binRanges[paymentMethodId].luhn ? validateLuhnAlgorithm(value) : true
    }

    const isValid = lengths.includes(value.length)
        && validateBin(value, paymentMethod, binRanges)
        && validateLuhn


    return {
        isValid,
        message: isValid ? "" : "Encontramos un error en esta tarjeta"
    }
}

export default withValidation(validation)(withStyles(style)(CardNumberInput))
